<template>
    <actions-menu v-model:dialogEdit="editRequestDialog" v-model:dialogConsult="editRequestDialog" :Id="Id"
        v-model:dialogDelete="dialog" :ShowDialogEdit="isEditMode" :ShowDialogDelete="isEditMode"
        :ShowDialogConsult="!isEditMode" />
    <dialogDelete :title="$t('ProductType.ProductType')" :yes="deleteRequest" v-model="dialog" />
    <v-dialog v-model="editRequestDialog">
        <v-card elevation="0" width="800px" style="padding: 20px; height: fit-content; border-radius: 12px;"
            class="py-2">
            <v-card-title> <span class="title">{{ $t('ProductType.Update') }}</span></v-card-title>
            <v-card-title class="text-left">{{ $t('ProductType.Name') }}<span class="red">*</span></v-card-title>
            <v-text-field v-model="ProductTypeName" id="Title" name="Title" maxlength="30" hide-details
                persistent-placeholder
                :placeholder="$t('placeholder.enter', { itm: $t('Brands.PlaceHolderTags.Name') })" variant="outlined"
                class="rounded-xl input-field"></v-text-field>
            <span class="warningHint" id="WarningMsgReference">{{ msg.ProductTypeName }}</span>

            <v-card-title class="text-left">{{ $t('ProductType.Category') }}<span class="red">*</span></v-card-title>
            <v-autocomplete v-model="TypeCategory" :items="productTypeCategories" item-title="name" item-value="value"
                variant="outlined" persistent-placeholder
                :placeholder="$t('placeholder.select', { itm: $t('ProductType.Category') })" hide-details
                class="rounded-xl input-field">
                <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" :value="item.value">
                        <v-list-item-title class="category-item">{{ item.name }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-autocomplete>
            <span class="warningHint" id="WarningMsgCategory">{{ msg.Category }}</span>




            <card-actions :yes="UpdateProductType" v-model:no="editRequestDialog" :loader="loader" :yesDisable="loader"
                width="300px" :yesTitle="$t('actions.save')" />
        </v-card>
    </v-dialog>
</template>


<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue"
import dialogDelete from "@/genericComponent/dialogDelete.vue"
import cardActions from "@/genericComponent/cardActions.vue"
import { UpdateProductType, DeleteProductType } from "@/api/index";
export default {
    components: { actionsMenu, dialogDelete, cardActions },
    props: ['idProductType', 'Id', 'getProductType', 'getProductTypeListAfterDelete'],
    data() {
        return {
            editRequestDialog: false,
            isEditMode: true,
            item: null,
            dialog: false,
            Title: null,
            msg: [],
            loader: false,
            ProductTypeName: null,
            TypeCategory: null
        };
    },
    computed: {
        productTypeCategories() {
            return [
                { name: this.$t('ProductType.Categories.Standard'), value: 0 },
                { name: this.$t('ProductType.Categories.Perishable'), value: 1 },
                { name: this.$t('ProductType.Categories.Fragile'), value: 2 },
                { name: this.$t('ProductType.Categories.Hazardous'), value: 3 },
                { name: this.$t('ProductType.Categories.Oversized'), value: 4 }
            ];
        },
    },
    mounted() {
        this.ProductTypeName = this.getProductType.name;
        this.TypeCategory = this.getProductType.typeCategory;
    },
    methods: {

        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        async UpdateProductType() {
            this.loader = true
            if (!this.ProductTypeName || this.ProductTypeName.length == 0) {
                this.msg["ProductTypeName"] = this.$t('warningInput.isrequired', { itm: this.$t('Brands.Name') });
                this.loader = false;
                return;
            }

            if (!this.TypeCategory && this.TypeCategory !== 0) {
                this.msg["Category"] = this.$t('warningInput.isrequired', { itm: this.$t('ProductType.Category') });
                this.loader = false;
                return;
            }

            this.msg["ProductTypeName"] = "";
            this.msg["Category"] = "";

            try {
                const response = await UpdateProductType(this.idProductType, this.ProductTypeName, this.TypeCategory);
                if (response.status == 200) {
                    this.editRequestDialog = false;
                    this.ActiveSavedSnackBar();
                    this.getProductTypeListAfterDelete();
                }
            } catch (error) {
                this.ActiveWarningSnackBar();
            }
            this.loader = false;

            this.loader = false

        },
        deleteRequest() {
            this.dialog = false
            DeleteProductType(this.idProductType)
                .then(() => {
                    this.ActiveDeletedSnackBar();
                    this.getProductTypeListAfterDelete();
                }).catch((error) => {
                    console.error(error)
                    this.ActiveWarningSnackBar()
                });
        }
    }
}
</script>
<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.v-card-text {
    font-family: inter;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #768da9;
}

.rounded-table {
    border-radius: 10px;
}

.custom-divider {
    border-top: 1px solid;
    border-color: currentColor;
}

.border-right {
    border: 1px solid #ddd;
    text-align: center;
    border-style: dotted;
    padding: 2px 4px;
}

.totals {
    margin-top: 20px;
    /* font-weight: bold; */
}

.align-right {
    padding-right: 85px;
    text-align: right;
    position: relative;
}

.totals p {
    margin: 5px 0;
}

.align-devise {
    float: right;
    margin-left: -16px;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #5b6d8e;
}

.textConsumptionThreshold {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 29px;
    display: flex;
    align-items: center;
    color: #080C3E;
}

.customWarningHint {
    color: #F25C5C;
    padding: 12px 0px 12px 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 0px;
    display: block;
    text-align: left;
    text-wrap: nowrap;
}

.input-field {
    width: 95%;
    margin-left: 12px;
}

.category-item {
    color: #000;
    font-family: inter;
    font-size: 14px;
}

.v-list-item {
    min-height: 44px;
}

.v-list-item-title {
    color: #000;
    padding: 8px;
}
</style>